import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import { StyledStatusLabel } from './StatusLabel.styles.js';
const _excluded = ["size", "color", "children"];
function StatusLabel(_ref) {
  let {
      size,
      color,
      children
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (!children) return null;
  return /*#__PURE__*/React__default.createElement(StyledStatusLabel, _extends({
    size: size,
    color: color
  }, otherProps), children);
}
StatusLabel.propTypes = {
  // StatusLabel size
  size: PropTypes.oneOf(['extraLarge', 'large', 'medium', 'small', 'extraSmall', 'extraSmallSmall']),
  // StatusLabel color
  color: PropTypes.oneOf(['primary', 'secondary', 'success', 'error', 'info', 'warning']),
  // StatusLabel text
  children: PropTypes.node
};
StatusLabel.defaultProps = {
  size: 'small',
  color: 'primary',
  children: null
};
export { StatusLabel as default };